<template>
    <TheLayout type="base">
        <main class="index-view container">
            <InsuranceProcess id="process"
                class="index-view__section"
                :showModalSubsciptionCancel = "showModalSubsciptionCancel"
                @close-cancel-modal="showModalSubsciptionCancel = false"
            />
        </main>
        <ModalPolicyIssuanceSuccess
            :visible="showPolicyIssuanceSuccessModal"
            modal-width="719px"
            @close="showPolicyIssuanceSuccessModal = false" />
    </TheLayout>
</template>

<script>
import TheLayout from '@/components/layouts/TheLayout';
import SectionLayout from '@/components/layouts/SectionLayout';
import TheIntroduction from '@/components/pages/index/TheIntroduction';
import InsuranceProcess from '@/components/pages/index/InsuranceProcess';
import ExecutionSteps from '@/components/pages/index/ExecutionSteps';
import CallToAction from '@/components/pages/index/CallToAction';
import BusinessAdvantages from '@/components/pages/index/BusinessAdvantages';
import ForWho from '@/components/pages/index/ForWho';
import InsuranceTargets from '@/components/pages/index/InsuranceTargets';
import CompensationSteps from '@/components/pages/index/CompensationSteps';
import TheFaq from '@/components/pages/index/TheFaq';
import ModalPolicyIssuanceSuccess from '@/components/modals/ModalPolicyIssuanceSuccess';

import scrollTo from '@/mixins/scrollTo';
import { GLOBAL_MODAL_KEYS_MAP } from '@/consts';

export default {
    name: 'IndexView',
    components: {
        TheLayout,
        SectionLayout,
        TheIntroduction,
        InsuranceProcess,
        ExecutionSteps,
        CallToAction,
        BusinessAdvantages,
        ForWho,
        InsuranceTargets,
        CompensationSteps,
        TheFaq,
        ModalPolicyIssuanceSuccess
    },
    mixins: [scrollTo],
    data() {
        return {
            showPolicyIssuanceSuccessModal: false,
            showModalSubsciptionCancel: false,
        }
    },
    methods: {
        callToActionCallback() {
            this.scrollTo('process')
        }
    },
    created() {
      document.title = 'Страхование ОСГОП онлайн - Zetta страхование';
    },
    mounted() {
        const { message } = this.$route.query;

        switch (message) {
            case GLOBAL_MODAL_KEYS_MAP.successPolicyIssuance:
                this.showPolicyIssuanceSuccessModal = true;
                break;
            default:
                break;
        }
    }
}
</script>

<style scoped lang="scss">
.index-view {
    &__section {
        $vertical-margin-desktop: $gap-large;
        $vertical-margin-desktop-min: 40px;

        @include resetting-vertical-indentation-of-first;

        margin-top: rem($vertical-margin-desktop);

        @media (#{$screen-big}) {
            margin-top: rem($vertical-margin-desktop-min);
        }
    }
}
</style>